export const textField = {
    MuiTextField: {
        variants: [
          {
            props: { variant: "outlined" },
            style: {
                // padding: "12px 24px",
              // "&:hover": {
              //   backgroundColor: "gray",
              // },
            },
          },
        ],
        styleOverrides: {
          // Name of the slot
          root: {
            // Some CSS
            // padding: "12px 24px",
            borderRadius: "12px"
          },
        },
      },
}